export const UPDATE_TWO_FACTOR_AUTH_MOBILE = 'updateTwoFactorAuthMobile';
export const UPDATE_PROFILE = 'updateProfile';
export const CREATE_STRESS_EVENTS = 'createStressEvents';
export const PERSIST_PAY_IT_OFF_UUID = 'persistPayItOffUuid';
